import { Megaphone } from 'lucide-react';
import { Marquee } from './Motion';
import { useSite } from '../../utils/site';

// Scrolling notices along the top of the public site - the Admin edits the
// list, label and speed on Administration -> Appearance -> Website & News.
export default function AnnouncementBar() {
  const site = useSite();
  if (!site.news_show || site.news_items.length === 0) return null;
  return (
    <div className="bg-brand-green-900 text-brand-green-50" role="region" aria-label="Announcements">
      <div className="flex items-center">
        <span className="z-10 flex shrink-0 items-center gap-1.5 bg-brand-gold-400 px-3 py-2 text-xs font-bold uppercase tracking-wide text-brand-green-950">
          <Megaphone className="h-3.5 w-3.5" aria-hidden="true" /> {site.news_label || 'News'}
        </span>
        <Marquee seconds={site.news_seconds} className="flex-1 py-2">
          {site.news_items.map((text, i) => (
            <span key={i} className="flex items-center gap-3 px-6 text-sm">
              <span className="skg-live-dot h-1.5 w-1.5 rounded-full bg-brand-gold-400" aria-hidden="true" />
              {text}
            </span>
          ))}
        </Marquee>
      </div>
    </div>
  );
}
